import React, { useState } from "react";

const SpinContext = React.createContext({
    spin: false,
    on: () => { },
    off: () => { },
});

export const SpinContextProvider = (props) => {
    const [spin, setSpin] = useState(false);

    const on = () => {
        setSpin(true);
    };

    const off = () => {
        setSpin(false);
    };

    const contextValue = {
        spin: spin,
        on: on,
        off: off,
    };

    return (
        <SpinContext.Provider value={contextValue}>
            {props.children}
        </SpinContext.Provider>
    );
};

export default SpinContext;